(function($) {

	// Animated stats block
	// $('.animated-counter').counterUp({
	// 	delay: 10,
	// 	time: 1000,
	// });

}(jQuery));